import { Injectable, OnDestroy } from '@angular/core';
import { BehaviorSubject, finalize, Subscription, take } from 'rxjs';
import { ILecturer } from '../../models/user/lecturer/lecturer.model';
import { ICallablesUsersLecturerGetResult, LecturersService } from '../entities/users/lecturers/lecturers.service';
import { SelectedOrgService } from '../selected-org.service';
import { UtilsService } from '../utils.service';
import { StoreService } from './store.service';

export interface ILecturersState {
  lecturers$: BehaviorSubject<ICallablesUsersLecturerGetResult>;
  fetchingLecturers$: BehaviorSubject<boolean>;

};

@Injectable({
  providedIn: 'root'
})
export class LecturersStoreService implements OnDestroy {

  private initState: ILecturersState = {
    lecturers$: new BehaviorSubject<ICallablesUsersLecturerGetResult>([]),
    fetchingLecturers$: new BehaviorSubject<boolean>(false),

  };
  public state = this.utilsService.initializeState(this.initState) as ILecturersState;

  private inited = false;
  private subs: Subscription[] = [];

  constructor(
    private utilsService: UtilsService,
    private lecturersService: LecturersService,
    private selectedOrgService: SelectedOrgService,
    private store: StoreService
  ) {
    this.subs.push(

      // ACTIONS

      // re-init on new org member
      this.store.actions.orgUsers_memberAdded$.subscribe(user => {
        this.init();
      }),
      //

      // re-init on org member update
      this.store.actions.orgUsers_memberUpdated$.subscribe(user => {
        this.init();
      }),
      //

      // lecturers fetched - store them
      this.store.actions.lecturers_lecturersFetched$.subscribe(lecturers => {
        this.state.lecturers$.next(lecturers);
      }),
      //
    );
  }

  public init(initOnlyIfNotInited = false) {
    if (initOnlyIfNotInited && this.inited) return;
    this.inited = true;
    this.reset();
    const orgId = this.selectedOrgService.getCurrentValue();
    if (!orgId) return;

    this.state.fetchingLecturers$.next(true);
    this.lecturersService.getAllLecturersInOrganization(orgId).pipe(
      take(1),
      finalize(() => this.state.fetchingLecturers$.next(false))
    ).subscribe({
      next: (res) => {
        this.store.actions.lecturers_lecturersFetched$.next(res);
      }
    });
  }

  private reset() {
    this.utilsService.resetState(this.initState, this.state);
  }


  ngOnDestroy(): void {
    this.subs.forEach(s => s.unsubscribe());
  }
}
